import {useEffect} from 'react';
import {useDocumentContext} from '@/components/document/context';
import {SUMMARY_SECTION} from '@/constants/sections';
import {useAuthentication} from '@/contexts/authentication';
import {useUserProfileContext} from '@/contexts/user-profile';
import {DocumentSection} from '@/engine';
import i18n from '@/initializers/i18next';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {getAnalyticsDocumentSectionPageName} from '@/services/analytics/get-analytics-document-section-page-name';

export const useFormPageViewEvent = () => {
  const {user} = useAuthentication();
  const {profile} = useUserProfileContext();
  const {currentSectionId, currentSection, currentSectionIndex} = useDocumentContext();

  useEffect(() => {
    const pageName = getCurrentSectionPageName(currentSectionId, currentSection);
    if (!pageName) {
      return;
    }

    analyticsHandler.webPageView({
      page_name: pageName,
      page_language: i18n.language as 'fr' | 'en',
      funnel_step: currentSectionIndex + 1,
      user_unique_id: user?.profile.sub || '',
      user_role: profile.advisorRole,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when section changes
  }, [currentSectionId]);
};

const getCurrentSectionPageName = (currentSectionId: string, currentSection: DocumentSection | null): string | null => {
  if (currentSectionId === SUMMARY_SECTION) {
    return 'document-sommaire';
  }

  if (currentSection) {
    return getAnalyticsDocumentSectionPageName(currentSection);
  }

  return null;
};
